import { makeVar, ReactiveVar } from "@apollo/client";
import { SortDirectionEnum } from "../spor-equipmnts/sort-direction.enum";
import {SortEquipmentRequestColumnsEnum} from "./sort-equipment-request-columns.enum";

export type EquipmentRequestListSortOrder = {
  [key in SortEquipmentRequestColumnsEnum as string]: SortDirectionEnum | null | undefined;
}

export const EquipmentRequestListSortOrderInitial: EquipmentRequestListSortOrder = {
  [SortEquipmentRequestColumnsEnum.RequestCreatedAt]: SortDirectionEnum.DESC
};

export const equipmentRequestListSortOrderVar = makeVar<EquipmentRequestListSortOrder>(
  EquipmentRequestListSortOrderInitial
);

export const useEquipmentRequestListSortOrderVar = () => createEquipmentRequestListSortOrderVar(equipmentRequestListSortOrderVar);

const createEquipmentRequestListSortOrderVar = (equipmentRequestListSortOrderVar: ReactiveVar<EquipmentRequestListSortOrder>) => {

  const setOrder = (orderModel: EquipmentRequestListSortOrder) => {
    // Ensure orderModel is a valid object and not an array or undefined
    if (orderModel && !Array.isArray(orderModel) && typeof orderModel === 'object') {
      equipmentRequestListSortOrderVar(orderModel);
    } else {
      equipmentRequestListSortOrderVar(EquipmentRequestListSortOrderInitial);
    }
  };

  return {
    setOrder
  };
};
